(function () {
  'use strict';

  var loaderScript = document.currentScript || document.querySelector('script[data-kk-live-search-src]');
  var source = loaderScript && loaderScript.getAttribute('data-kk-live-search-src');
  var state = 'idle';
  var supportsPointerEvents = 'PointerEvent' in window;

  if (!source || window.__kkLiveSearchLoaderAttached) {
    return;
  }

  window.__kkLiveSearchLoaderAttached = true;

  function decodeValue(value) {
    try {
      return decodeURIComponent(String(value || '').replace(/\+/g, '%20'));
    } catch (error) {
      return String(value || '').replace(/\+/g, ' ');
    }
  }

  function getSearchForm(target) {
    if (!target || !target.closest) {
      return null;
    }

    if (target.matches && target.matches('[data-live-search-form]')) {
      return target;
    }

    return target.closest('[data-live-search-form]');
  }

  function syncSearchForm(form) {
    var visibleInput = form && form.querySelector('[data-kk-search-visible-input]');
    var queryInput = form && form.querySelector('[data-kk-search-query-input]');

    if (!visibleInput || !queryInput) {
      return false;
    }

    queryInput.value = decodeValue(visibleInput.value).trim();
    return true;
  }

  function removeIntentListeners() {
    document.removeEventListener('focusin', handleIntent, true);
    document.removeEventListener('pointerdown', handleIntent, true);
    document.removeEventListener('touchstart', handleIntent, true);
    document.removeEventListener('keydown', handleIntent, true);
    document.removeEventListener('input', handleIntent, true);
    document.removeEventListener('submit', handleIntent, true);
  }

  function loadLiveSearch() {
    var script;

    // Collection and search routes may already expose only the scoped query
    // helpers through their filter bundle. That does not mean the actual
    // predictive-search controller has been loaded yet.
    if (window.KKNativeLiveSearch) {
      state = 'loaded';
      removeIntentListeners();
      return;
    }

    if (state !== 'idle') {
      return;
    }

    state = 'loading';
    script = document.createElement('script');
    script.src = source;
    script.async = true;
    script.setAttribute('data-kk-live-search-script', '');

    script.addEventListener('load', function () {
      state = 'loaded';
      removeIntentListeners();
    });

    script.addEventListener('error', function () {
      state = 'idle';
      script.remove();
    });

    document.head.appendChild(script);
  }

  function handleIntent(event) {
    var form = getSearchForm(event.target);

    if (!syncSearchForm(form)) {
      return;
    }

    loadLiveSearch();
  }

  document.addEventListener('focusin', handleIntent, true);
  document.addEventListener('pointerdown', handleIntent, true);

  if (!supportsPointerEvents) {
    document.addEventListener('touchstart', handleIntent, true);
  }

  document.addEventListener('keydown', handleIntent, true);
  document.addEventListener('input', handleIntent, true);
  document.addEventListener('submit', handleIntent, true);

  if (document.activeElement && document.activeElement.matches('[data-kk-search-visible-input]')) {
    handleIntent({ target: document.activeElement });
  }
}());
